import axiosInstance from "../../components/api/axiosInstance";

/** Circles admin API (cloud-office-api /circles/*). Each call resolves to { data, ...extra } or throws Error(message). */
async function call(method, url, body, params) {
  try {
    const res = await axiosInstance.request({ method, url, data: body, params });
    return res.data || {};
  } catch (err) {
    const msg = err?.response?.data?.message || err?.response?.data?.error || err?.message || "Something went wrong.";
    throw new Error(msg);
  }
}

const list = (data) => (Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : []);

export const circlesApi = {
  inbox: (params) => call("get", "/circles/inbox", null, params),
  convertInbox: (id, body) => call("post", `/circles/inbox/${id}/convert`, body),
  rejectInbox: (id, note) => call("post", `/circles/inbox/${id}/reject`, { note }),

  agents: (params) => call("get", "/circles/agents", null, params),
  approveAgent: (id, domainIds) => call("post", `/circles/agents/${id}/approve`, { domain_ids: domainIds }),
  agentStatus: (id, status, note) => call("post", `/circles/agents/${id}/status`, { status, note }),
  agentDomain: (id, domainId, approve) => call("post", `/circles/agents/${id}/domains/${domainId}`, { approve }),

  projects: () => call("get", "/circles/projects"),
  createProject: (body) => call("post", "/circles/projects", body),
  updateProject: (id, body) => call("put", `/circles/projects/${id}`, body),
  newAppKey: (id) => call("post", `/circles/projects/${id}/app-key`),

  appReferrals: (params) => call("get", "/circles/app-referrals", null, params),
  confirmReferral: (id, body) => call("post", `/circles/app-referrals/${id}/confirm`, body),
  rejectReferral: (id, reason) => call("post", `/circles/app-referrals/${id}/reject`, { reason }),
  giftApplied: (id) => call("post", `/circles/app-referrals/${id}/gift-applied`),

  commissions: (params) => call("get", "/circles/commissions", null, params),
  decideCommission: (id, status, note) => call("post", `/circles/commissions/${id}/decide`, { status, note }),

  payouts: () => call("get", "/circles/payouts"),
  recordPayout: (body) => call("post", "/circles/payouts", body),

  settings: () => call("get", "/circles/settings"),
  saveSettings: (body) => call("put", "/circles/settings", body),

  dashboardHandoff: () => call("post", "/circles/staff-dashboard/handoff"),

  domains: async () => list(await call("get", "/domains")).map((d) => ({ id: d.Domain_Id ?? d.id, name: d.Domain_Name ?? d.name })),
  tenantProjects: async (tenantId) =>
    list(await call("get", "/tenant-projects/", null, { tenant_id: tenantId })).map((p) => ({ id: p.Tenant_Project_Id, name: p.Project_Name })),
};

/**
 * Open the Digix staff dashboard signed in (one-time token from Cloud Office). The tab is opened first,
 * inside the click, so pop-up blockers allow it; it is pointed at the dashboard once the token arrives.
 */
export async function openStaffDashboard() {
  const tab = window.open("", "_blank");
  try {
    const { data } = await circlesApi.dashboardHandoff();
    if (tab) {
      tab.opener = null;
      tab.location.replace(data.url);
    } else {
      window.location.assign(data.url);
    }
  } catch (err) {
    if (tab) tab.close();
    window.alert(err.message);
  }
}
